import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import GoogleSignInPlugin from "vue3-google-signin"
import './styles/brand-system.css'

loadFonts()

createApp(App)
  .use(store)
  .use(router)
  .use(vuetify)
  .use(GoogleSignInPlugin, {
    clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID
  })
  .mount('#app')
